import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Component, Inject } from '@angular/core';
import { NgbDatepickerModule, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'sick-note',
  templateUrl: './doctor-letter.modal.html',
  imports: [ReactiveFormsModule, NgbDatepickerModule, CommonModule],
  styleUrls: ['./doctor-letter.modal.scss'],
})
export class DoctorLetterModal {
  sickNoteForm: FormGroup;
  today: NgbDateStruct;
  futureDate: NgbDateStruct;

  constructor(
    public dialogRef: MatDialogRef<DoctorLetterModal>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
  ) {
    // Initialize properties with data passed to the modal
    this.sickNoteForm = this.fb.group({
      notes: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
    });

    const date = new Date();

    this.today = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
    };

    this.futureDate = {
      year: date.getFullYear(),
      month: date.getMonth() + 2,
      day: date.getDate(),
    };
  }

  saveSickNote() {
    if (!this.sickNoteForm.valid) return;

    let startDate = this.sickNoteForm.get('startDate')?.value;
    let toDate = this.sickNoteForm.get('endDate')?.value;

    this.dialogRef.close({
      notes: this.sickNoteForm.get('notes')?.value,
      fromDate: new Date(startDate.year, startDate.month - 1, startDate.day),
      toDate: new Date(toDate.year, toDate.month - 1, toDate.day),
    });
  }

  cancel() {
    this.dialogRef.close();
  }
}
